import { useEffect, useState } from "react";
import YourChild from "../../Components/YourChild";

const YourChildPage = () => {
  return (
      <>
        <YourChild />
      </>
  );
};

export default YourChildPage;
